import { render } from "./RelationshipAdd.vue?vue&type=template&id=88cc7fae&ts=true"
import script from "./RelationshipAdd.vue?vue&type=script&lang=ts"
export * from "./RelationshipAdd.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__